import { SvgIcon, SvgIconProps } from '@material-ui/core';

const DotIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16">
      <g
        id="icon-circle_node"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="streamline-icon-interface-time-clock-circle@20x20"
          transform="translate(2.000000, 2.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path
            d="M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,7.59129894 11.367859,9.11742242 10.2426407,10.2426407 C9.11742242,11.367859 7.59129894,12 6,12 Z"
            id="Shape"
          ></path>
        </g>
        <rect id="Rectangle" x="0" y="0" width="16" height="16"></rect>
      </g>
    </SvgIcon>
  );
};

export default DotIcon;
